function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import omit from "lodash.omit";
import atIds from "@brandwatch/axiom-automation-testing/ids";
import { AlertBar, Button, ButtonGroup, Dialog, DialogBody, DialogHeader, Form, Heading, ProgressButton, Paragraph } from "@brandwatch/axiom-components";
import { translate } from "@brandwatch/axiom-localization";
import ConfirmPasswordInput from "../FormInputs/ConfirmPasswordInput";
import CurrentPasswordInput from "../FormInputs/CurrentPasswordInput";
import NewPasswordInput from "../FormInputs/NewPasswordInput";
const t = translate({
  "Change Password": {
    de: "Passwort ändern",
    es: "Cambiar Contraseña",
    fr: "Changement de votre mot de passe"
  },
  "Please complete all the password fields": {
    de: "Es tut uns leid, Sie müssen alle Passwortfelder ausfüllen",
    es: "Lo sentimos, debe completar todos los campos de contraseña",
    fr: "Désolé, vous devez compléter tous les champs de mot de passe"
  },
  Cancel: {
    de: "Abbrechen",
    es: "Cancelar",
    fr: "Effacer"
  }
});
export default class ChangePasswordDialog extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      confirmPassword: "",
      currentPassword: "",
      validationError: "",
      newPassword: ""
    };
  }

  handleSubmit(event, validationError) {
    const {
      onSubmit
    } = this.props;
    const {
      currentPassword,
      newPassword
    } = this.state;
    event.preventDefault();
    this.setState({
      validationError
    });

    if (!validationError) {
      onSubmit({
        currentPassword,
        newPassword
      });
    }
  }

  render() {
    const {
      axiomLanguage
    } = this.context;
    const {
      error,
      isCurrentPasswordInvalid,
      isSubmitting,
      onRequestClose,
      ...rest
    } = this.props;
    const {
      confirmPassword,
      currentPassword,
      newPassword,
      validationError
    } = this.state;
    return /*#__PURE__*/React.createElement(Dialog, _extends({}, omit(rest, ["onSubmit"]), {
      onRequestClose: onRequestClose,
      size: "medium"
    }), /*#__PURE__*/React.createElement(DialogHeader, null, /*#__PURE__*/React.createElement(Heading, {
      textSize: "headtitle"
    }, t("Change Password", axiomLanguage))), /*#__PURE__*/React.createElement(Form, {
      onSubmit: this.handleSubmit,
      requiredError: t("Please complete all the password fields")
    }, (validationError || error) && /*#__PURE__*/React.createElement(AlertBar, {
      type: "error"
    }, /*#__PURE__*/React.createElement(Paragraph, {
      "data-ax-at": atIds.ChangePassword.error
    }, validationError || error)), /*#__PURE__*/React.createElement(DialogBody, null, /*#__PURE__*/React.createElement(CurrentPasswordInput, {
      "data-ax-at": atIds.ChangePassword.currentPassword,
      invalid: isCurrentPasswordInvalid,
      onChange: e => this.setState({
        currentPassword: e.target.value
      }),
      value: currentPassword
    }), /*#__PURE__*/React.createElement(NewPasswordInput, {
      "data-ax-at": atIds.ChangePassword.newPassword,
      onChange: e => this.setState({
        newPassword: e.target.value
      }),
      value: newPassword
    }), /*#__PURE__*/React.createElement(ConfirmPasswordInput, {
      "data-ax-at": atIds.ChangePassword.confirmPassword,
      onChange: e => this.setState({
        confirmPassword: e.target.value
      }),
      passwordValue: newPassword,
      value: confirmPassword
    }), /*#__PURE__*/React.createElement(ButtonGroup, {
      textRight: true
    }, /*#__PURE__*/React.createElement(Button, {
      "data-ax-at": atIds.ChangePassword.cancel,
      onClick: onRequestClose,
      variant: "secondary",
      type: "button"
    }, t("Cancel", axiomLanguage)), /*#__PURE__*/React.createElement(ProgressButton, {
      "data-ax-at": atIds.ChangePassword.submit,
      disabled: isSubmitting,
      isInProgress: isSubmitting,
      type: "submit"
    }, t("Change Password", axiomLanguage))))));
  }

}

_defineProperty(ChangePasswordDialog, "contextTypes", {
  axiomLanguage: PropTypes.string
});

_defineProperty(ChangePasswordDialog, "defaultProps", {
  isCurrentPasswordInvalid: false,
  isSubmitting: false
});